module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "has-text-left",
    class: {
      'direction-rtl': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('div', {
    staticClass: "box"
  }, [_c('h4', {
    staticClass: "title",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('span', {
    staticClass: "has-text-danger"
  }, [_vm._v(_vm._s(_vm.$t("price_estimate")))])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('lydiax_withdrawal_note', {
    currency: _vm.User.wallet.currency,
    crypto: _vm.selectedCrypto.name || 'crypto'
  })))]), _vm._v(" "), _c('div', {
    staticClass: "box",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_c('label', {
    attrs: {
      "for": "estimate"
    }
  }, [_vm._v(_vm._s(_vm.$t('enter_currency_amount', {
    currency: _vm.User.wallet.currency
  })))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('decimal:10'),
      expression: "'decimal:10'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.estimate.fiat),
      expression: "estimate.fiat"
    }],
    staticClass: "input",
    attrs: {
      "name": "estimate",
      "type": "text"
    },
    domProps: {
      "value": (_vm.estimate.fiat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.estimate, "fiat", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('estimate')),
      expression: "errors.has('estimate')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('estimate')))])])]), _vm._v(" "), _c('a', {
    staticClass: "button is-success",
    on: {
      "click": _vm.estimatePrice
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check",
    class: {
      'ml-10': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('check_price')))])]), _vm._v(" "), (_vm.estimate.crypto) ? _c('span', {
    staticClass: "is-size-5 has-text-danger"
  }, [_vm._v(_vm._s(_vm.$t('estimated')) + " " + _vm._s(_vm.estimate.crypto.toFixed(10)) + " " + _vm._s(_vm.selectedCrypto.code || 'crypto'))]) : _vm._e()])]), _vm._v(" "), _c('h5', {
    staticClass: "title is-fullwidth",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t("select_cryptocurrency")))]), _vm._v(" "), _c('div', {
    staticClass: "field",
    class: {
      'is-pulled-right': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-left': _vm.Language != 'fa' && _vm.Language != 'ar'
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.cryptocurrency),
      expression: "cryptocurrency"
    }],
    attrs: {
      "name": "currency"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.cryptocurrency = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.$validator.clean()
      }]
    }
  }, _vm._l((_vm.cryptocurrencyOptions), function(crypto, i) {
    return (crypto.code !== 'ETH') ? _c('option', {
      key: 'crypto-options-' + i,
      domProps: {
        "value": crypto.code
      }
    }, [_vm._v(_vm._s(crypto.name))]) : _vm._e()
  }), 0)])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.networkOpts.length > 1) ? _c('div', [_c('h5', {
    staticClass: "title",
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_vm._v("Select your " + _vm._s(_vm.cryptocurrency) + " network:")]), _vm._v(" "), _c('div', {
    staticClass: "control"
  }, [_c('span', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.network),
      expression: "network"
    }],
    attrs: {
      "name": "currency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.network = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.networkOpts), function(netw, i) {
    return _c('option', {
      key: 'network-' + i,
      domProps: {
        "value": netw
      }
    }, [_vm._v(_vm._s(netw))])
  }), 0)])])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.networkWarning[_vm.cryptocurrency] && _vm.networkWarning[_vm.cryptocurrency].length > 0) ? _c('div', {
    staticClass: "has-text-danger"
  }, [(_vm.cryptocurrency == 'BTC') ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('bitpace_network_warning_BTC_withdrawal')) + "\n    ")]) : (_vm.cryptocurrency == 'ETH') ? _c('div') : (_vm.cryptocurrency == 'LTC') ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('bitpace_network_warning_LTC_withdrawal')) + "\n    ")]) : (_vm.cryptocurrency == 'XRP') ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('bitpace_network_warning_XRP_withdrawal')) + "\n    ")]) : (_vm.cryptocurrency == 'BCH') ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('bitpace_network_warning_BCH_withdrawal')) + "\n    ")]) : (_vm.cryptocurrency == 'USDT') ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('bitpace_network_warning_USDT_withdrawal')) + "\n    ")]) : (_vm.cryptocurrency == 'USDC') ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('bitpace_network_warning_USDC_withdrawal')) + "\n    ")]) : (_vm.cryptocurrency == 'TRX') ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('bitpace_network_warning_TRX_withdrawal')) + "\n    ")]) : (_vm.cryptocurrency == 'LINK') ? _c('div', [_vm._v("\n      " + _vm._s(_vm.$t('bitpace_network_warning_LINK_withdrawal')) + "\n    ")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('h5', {
    staticClass: "title is-fullwidth",
    class: {
      'is-pulled-right': _vm.Language == 'fa' || _vm.Language == 'ar', 'is-pulled-left': _vm.Language != 'fa' && _vm.Language != 'ar'
    }
  }, [_vm._v(_vm._s(_vm.$t('please_enter_your_crypto_address', {
    crypto: _vm.selectedCrypto.name
  })))]), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.cryptoAddress),
      expression: "cryptoAddress"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('cryptoAddress')
    },
    attrs: {
      "name": "cryptoAddress",
      "type": "text",
      "data-vv-as": _vm.$t('your_crypto_address', {
        crypto: this.selectedCrypto.name
      }),
      "placeholder": _vm.$t('your_crypto_address', {
        crypto: this.selectedCrypto.name
      })
    },
    domProps: {
      "value": (_vm.cryptoAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.cryptoAddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('cryptoAddress')),
      expression: "errors.has('cryptoAddress')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('cryptoAddress')))])])]), _vm._v(" "), (_vm.selectedCrypto.code === 'XRP') ? _c('div', {
    staticClass: "field"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.destinationTag),
      expression: "destinationTag"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('destinationTag')
    },
    attrs: {
      "name": "destinationTag",
      "type": "text",
      "data-vv-as": _vm.$t('destination_tag'),
      "placeholder": _vm.$t('destination_tag')
    },
    domProps: {
      "value": (_vm.destinationTag)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.destinationTag = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destinationTag')),
      expression: "errors.has('destinationTag')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('destinationTag')))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "field"
  }, [_c('label', {
    staticClass: "label",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    },
    attrs: {
      "for": "OTP"
    }
  }, [_vm._v(_vm._s(_vm.$t("otp")))]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-8"
  }, [_c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.OTP),
      expression: "OTP"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('OTP')
    },
    attrs: {
      "name": "OTP",
      "type": "text",
      "data-vv-as": 'OTP',
      "placeholder": 'OTP'
    },
    domProps: {
      "value": (_vm.OTP)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.OTP = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('OTP')),
      expression: "errors.has('OTP')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('OTP')))])]), _vm._v(" "), _c('div', {
    staticClass: "column is-4"
  }, [_c('button', {
    attrs: {
      "disabled": !_vm.otpBtnEnabled
    },
    on: {
      "click": function($event) {
        return _vm.generateOTP()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("otp_send_email")))])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "field has-addons"
  }, [_c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-static"
  }, [_vm._v(_vm._s(_vm.currencySymbols[_vm.User.wallet.currency].symbol))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [(_vm.User.wallet.currency === 'USD') ? _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|currency|min_value:65'),
      expression: "'required|currency|min_value:65'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('amount')
    },
    attrs: {
      "name": "amount",
      "type": "text",
      "data-vv-as": _vm.$t('amount'),
      "placeholder": _vm.$t('amount')
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }) : _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|currency|min_value:50'),
      expression: "'required|currency|min_value:50'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }],
    class: {
      'input': true, 'is-danger': _vm.errors.has('amount')
    },
    attrs: {
      "name": "amount",
      "type": "text",
      "data-vv-as": _vm.$t('amount'),
      "placeholder": _vm.$t('amount')
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('amount')),
      expression: "errors.has('amount')"
    }],
    staticClass: "help is-danger",
    class: {
      'has-text-right': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  }, [_vm._v(_vm._s(_vm.errors.first('amount')))])]), _vm._v(" "), _c('p', {
    staticClass: "control"
  }, [_c('a', {
    staticClass: "button is-success",
    on: {
      "click": _vm.withdraw
    }
  }, [_c('span', {
    staticClass: "icon is-small"
  }, [_c('i', {
    staticClass: "fa fa-check",
    class: {
      'ml-10': _vm.Language == 'fa' || _vm.Language == 'ar'
    }
  })]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("withdraw").tTitle()))])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d8e72302"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/finance/withdraw-methods/Lydiax.vue
// module id = 812
// module chunks = 0